if (!customElements.get('infinite-scroll-collection')) {
  class InfiniteScrollCollection extends HTMLElement {
    constructor() {
      super();
      this.sectionId = this.dataset.sectionId;
      this.currentPage = parseInt(this.dataset.currentPage, 10) || 1;
      this.totalPages = parseInt(this.dataset.totalPages, 10) || 1;
      this.isLoading = false;
      this.grid = document.getElementById('Slider-' + this.sectionId);
      this.observer = new IntersectionObserver(this.onIntersect.bind(this), {
        rootMargin: '600px 0px 0px 0px',
        threshold: 0
      });
    }

    connectedCallback() {
      if (!this.grid || this.currentPage >= this.totalPages) {
        this.remove();
        return;
      }
      this.observer.observe(this);
    }

    disconnectedCallback() {
      this.observer.disconnect();
    }

    onIntersect(entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting && !this.isLoading) {
          this.loadNextPage();
        }
      }.bind(this));
    }

    loadNextPage() {
      if (this.currentPage >= this.totalPages) {
        this.stopObserving();
        return;
      }

      this.isLoading = true;
      this.classList.add('infinite-scroll--loading');

      var nextPage = this.currentPage + 1;
      var url = window.location.pathname + '?page=' + nextPage + '&section_id=' + this.sectionId;

      fetch(url)
        .then(function (response) {
          if (!response.ok) {
            throw new Error('Infinite scroll fetch failed: ' + response.status);
          }
          return response.text();
        })
        .then(function (text) {
          var doc = new DOMParser().parseFromString(text, 'text/html');
          var newGrid = doc.getElementById('Slider-' + this.sectionId);

          if (newGrid) {
            var newItems = newGrid.querySelectorAll('.grid__item');
            newItems.forEach(function (item) {
              item.classList.remove('scroll-trigger', 'animate--slide-in');
              item.removeAttribute('data-cascade');
              item.style.removeProperty('--animation-order');
              this.grid.appendChild(item);
            }.bind(this));
          }

          this.currentPage = nextPage;

          if (this.currentPage >= this.totalPages) {
            this.stopObserving();
          }
        }.bind(this))
        .catch(function (error) {
          console.error(error);
          this.stopObserving();
        }.bind(this))
        .finally(function () {
          this.isLoading = false;
          this.classList.remove('infinite-scroll--loading');
        }.bind(this));
    }

    stopObserving() {
      this.observer.disconnect();
      this.remove();
    }
  }

  customElements.define('infinite-scroll-collection', InfiniteScrollCollection);
}